import types from '../constants/types'
import config from '@/config'
import cookies from 'js-cookie'
import { toQueryString, redirect } from '@/utils'
import axios from 'axios'

export const authorityAction = {
  wxAccess({ commit, state }, param, apiParam = config.apiParam) {
    commit(types.LOGIN_REQUEST)
    axios({
      method: 'post',
      baseURL: config.serviceHost,
      url: '/' + config.apiVersion + '/common/login',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      timeout: 60000,
      data: Object.assign({
        'token': config.apiToken
      },
      param.data,
      apiParam)
    })
      .then((res) => {
        if (res && res.status === 200) {
          if (res.data.code !== '000000' && res.data.code !== '0') {
            if (['000001', '000002', '000003', '000004', '000005'].indexOf(res.data.code) > -1) {
              redirect('/')
              return
            }
            commit(types.LOGIN_FAILURE, {
              data: res.data
            })
            if (typeof param.onFail === 'function') {
              param.onFail(res.data)
            }
          } else {
            commit(types.LOGIN_SUCCESS, {
              data: res.data
            })
            const token = res.data.info.token
            const nickname = res.data.info.nickname
            const headimgurl = res.data.info.headimgurl
            cookies.set('token', token)
            cookies.set('nickname', nickname)
            cookies.set('headimgurl', headimgurl)
            if (typeof param.onSuccess === 'function') {
              param.onSuccess(res.data)
            }
          }
        }
      })
      .catch((error) => {
        commit(types.LOGIN_FAILURE, {
          data: error
        })
        if (typeof param.onFail === 'function') {
          if (config.debug) {
            param.onFail({ msg: JSON.stringify(error) })
          } else {
            param.onFail({ msg: '服务器无响应' })
          }
        }
      })
  },
  reLogin({ commit, state }, param) {
    const token = cookies.get('token')
    const nickname = cookies.get('nickname')
    const headimgurl = cookies.get('headimgurl')
    if (token) {
      commit(types.LOGIN_SUCCESS, {
        data: {
          info: {
            nickname: nickname,
            headimgurl: headimgurl,
            token: token
          },
          msg: '登录成功'
        }
      })
      if (typeof param.onSuccess === 'function') {
        param.onSuccess()
      }
    } else {
      commit(types.LOGIN_FAILURE)
      if (typeof param.onFail === 'function') {
        param.onFail()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/authority.js